import {
  Box,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuProps,
  Typography,
} from '@mui/material';
import { forwardRef } from 'react';
import { IDriveContent } from 'src/@types/drive';
import { useDriveContentQuery } from 'src/hooks/useDriveContentQuery';
import { useLocales } from 'src/locales';
import Iconify from '../../iconify';
import { ExplorerMenu } from '../shared/ExplorerMenu';
import { DriveExplorerItem } from './DriveExplorerItem';

type DriveExplorerProps = MenuProps & {
  selectFile: (file: IDriveContent) => void;
  isSelected: (file: IDriveContent) => boolean;
  validMimeTypes: string[];
};

export const DriveExplorer = forwardRef<any, DriveExplorerProps>(
  (
    { selectFile, isSelected, validMimeTypes, open, anchorEl, onClose },
    ref,
  ) => {
    const { translate } = useLocales();

    const { driveContents, isDriveContentLoading } = useDriveContentQuery();

    return (
      <ExplorerMenu ref={ref} open={open} anchorEl={anchorEl} onClose={onClose}>
        <Typography variant="caption" color="text.secondary">
          {translate('header.nav_vertical.drive')}
        </Typography>

        <Box>
          {isDriveContentLoading ? (
            <MenuItem>
              <ListItemIcon>
                <Iconify icon="eos-icons:loading" />
              </ListItemIcon>
              <ListItemText>Loading</ListItemText>
            </MenuItem>
          ) : (
            driveContents?.map((item) => (
              <DriveExplorerItem
                key={item._id}
                driveItem={item}
                selectFile={selectFile}
                isSelected={isSelected}
                validMimeTypes={validMimeTypes}
              />
            ))
          )}
        </Box>
      </ExplorerMenu>
    );
  },
);
